import $ from "jquery";

// Function to handle accordion toggle
export function toggleAccordion($trigger: JQuery<HTMLElement>): void {
    const $icon = $trigger.find(".accordion-icon");
    const $triggerUp = $trigger.hasClass("accordion-trigger-up");
    const $content = $triggerUp ? $trigger.siblings(".accordion-content").first() : $trigger.next(".accordion-content");

    if ($trigger.hasClass("is-active")) {
        $content.slideUp();
        $icon.removeClass("rotate-45");
        $trigger.removeClass("is-active").attr("aria-expanded", "false");
        $content.attr("aria-hidden", "true");
    } else {
        $content.slideDown();
        $icon.addClass("rotate-45");
        $trigger.addClass("is-active").attr("aria-expanded", "true");
        $content.attr("aria-hidden", "false");
    }
}

export function toggleAllAccordions($trigger: JQuery<HTMLElement>, displayAll: boolean): void {
    const triggers = $trigger.closest("table").find(".accordion-trigger").toArray();
    const contents = $trigger.closest("table").find(".accordion-content").toArray();
    const displayAllTriggers = $trigger.closest("table").find(".accordion-trigger-all").first();

    if (!displayAll) {
        $(displayAllTriggers).addClass("is-active").attr("aria-expanded", "true");
        triggers.forEach((trigger) => {
            $(trigger).addClass("is-active").attr("aria-expanded", "true");
        });

        contents.forEach((content) => {
            $(content).slideDown();
            $(content).attr("aria-hidden", "false");
        });
    } else {
        $(displayAllTriggers).removeClass("is-active").attr("aria-expanded", "false");
        triggers.forEach((trigger) => {
            $(trigger).removeClass("is-active").attr("aria-expanded", "false");
        });

        contents.forEach((content) => {
            $(content).slideUp();
            $(content).attr("aria-hidden", "true");
        });
    }
}

$(function () {
    // Cache the document object
    const $document = $(document);

    // Event delegation for accordion trigger click
    $document.on("click", ".accordion-trigger", function (e) {
        e.stopPropagation();
        toggleAccordion($(this) as JQuery<HTMLElement>);
    });

    $document.on("click", ".toggle-all-accordions", function (e) {
        const displayAll = $(e.target).closest("button").attr("data-accordion-display-all") == "true";
        $(e.target).closest("button").attr("data-accordion-display-all", (!displayAll).toString());
        toggleAllAccordions($(this) as JQuery<HTMLElement>, displayAll);
    });
});
